import { lazy } from 'react';
const VerPlanInq = lazy(() => import('./VerPlanInq'));

const verPlanInqRoutes = [
  {
    path: '/verplaninq',
    component: VerPlanInq
  }
];

export default verPlanInqRoutes;
